import { combineReducers } from "redux";
import modalReducer from "../containers/Modal/services/reducer";
import agentReducer from "./agent/reducer";

export default () =>
  combineReducers({
    modal: modalReducer,
    agent: agentReducer,
  });
